import { Injectable } from '@angular/core';

@Injectable()
export class BrowserOnlyGuard {
  constructor() {}

  canActivate(): boolean {
    return window.MINGA_APP_BROWSER;
  }
}
